import React, { Component } from "react";

import ColorPickerExample from "./examples/color-picker";
import MultiSelectExamples from "./examples/multi-select";
import RichTextExample from "./examples/rich-text";
import TypeaheadExamples from "./examples/typeahead";
import AsyncTypeaheadExamples from "./examples/async-typeahead";
import MeasurementExamples from "./examples/measurement";
import { DimensionsInput } from "../form-inputs/custom/dimensions";
import TabExample from "./examples/tabs";
import TextareaListExamples from "./examples/textarea-list";
import { NumberField } from "../form-inputs/inputs";

class StyleguideIndex extends Component {
    constructor(props) {
        super();
        this.state = {
            smoothed: {
                itemHeight: {
                    value: "1",
                    uom: {
                        value: "ft",
                        text: "Foot",
                        tags: ["length"],
                    },
                },
                itemWidth: {
                    value: "2",
                    uom: {
                        value: "mm",
                        text: "Millimeter",
                        tags: ["length"],
                    },
                },
                itemDepth: {
                    value: "3",
                    uom: {
                        value: "cm",
                        text: "Centimeter",
                        tags: ["length"],
                    },
                },
            },
        };
    }

    updateField = (name, value) => {
        this.setState({
            [name]: value,
        });
    };

    render() {
        return (
            <div className="container">
                <h1>Number</h1>
                <NumberField name="numberField" max="3" />
                <h1>Tabs</h1>
                <TabExample />
                <h1>Textarea List</h1>
                <TextareaListExamples />
                <h1>Multi-Select</h1>
                <MultiSelectExamples />
                <h1>Rich Text</h1>
                <RichTextExample />
                <h1>ColorPicker</h1>
                <ColorPickerExample />
                <h1>Styleguide</h1>
                <DimensionsInput name="smoothed" defaultValue={this.state.smoothed} updateOnChange={this.updateField} />
                <TypeaheadExamples />
                <AsyncTypeaheadExamples />
                <MeasurementExamples />
            </div>
        );
    }
}

export default StyleguideIndex;
